<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    scrollable
  >
    <template v-slot:activator="{ on, attrs}">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="$router.push({name: 'AdministratorUserNotificationDelete'})"
        >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense>
        {{ $route.meta.nameDrawer }}
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-title>
        ID: {{ notification.id }}
      </v-card-title>
      <v-card-text>
        {{ notification.description }}
      </v-card-text>

      <v-card-text class="text-left pb-0 white--text">
        {{ $t("wantToDeleteThisMessage") }}
      </v-card-text>

      <v-card-actions class="pa-4" style="gap: 8px">
        <v-spacer></v-spacer>
        <v-btn
          :class="deletingMessage ? '' : 'white black--text'"
          @click="closeDialog"
          outlined
          small
          :loading="deletingMessage"
          :disabled="deletingMessage"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          @click="confirm"
          color="#B50000"
          small
          :loading="deletingMessage"
          :disabled="deletingMessage"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "delete-notification",
  props: {
    notification: {
      type: Object
    }
  },
  data: () => ({
    deletingMessage: false,
    dialog: false,
  }),

  methods: {
    closeDialog() {
      this.dialog = false;
      this.$router.go(-1);
    },

    confirm() {
      this.deletingMessage = true;

      const body = {
        id_notification: [this.notification.id],
      }

      this.$axios
        .post(
          "/administrator/Notifications/removeNotification",
          body
        )
        .then((resp) => {
          this.deletingMessage = false;

          this.$store.commit("setFeedbackSnack", {
            msg: resp.data.messages,
            color: "success"
          })
          this.$emit("fetchNotificationsList", true);
          this.closeDialog();
        })
        .catch(() => {
          this.deletingMessage = false;
        })
    }
  }
}
</script>